import animations from "../animations/declaratives";

const animationOnScreenDelegate = {
    observer : undefined,
    observed : [],
    observe(el, callback, ratio = 0.1){
        this.observer.observe(el);
        this.observed = [...this.observed, {
            el: el,
            callback: callback,
            ratio: ratio
        }];
    },
    init(){
        this.observer = new IntersectionObserver(this.observerCallback.bind(this), { rootMargin: "0px", threshold: 0.1 })
    },
    unobserve(el) {
        this.observer.unobserve(el);
        this.observed = this.observed.filter(x => x.el !== el);
    },
    observerCallback(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.setAttribute('data-intersect', 1);
                const intersected = this.observed.find(x => x.el === entry.target);
                if (intersected) {
                    intersected.callback(entry);
                }
            } else {
                if (entry.target.getAttribute('data-intersect', 0)) {
                    const intersected = this.observed.find(x => x.el === entry.target);
                    if (intersected) {
                        intersected.callback(entry);
                    }
                    entry.target.setAttribute('data-intersect', 0);
                }

            }
        })
    }
} 

/**
 * Parse les paramètres des animations
 * @param {String} attributeContent 
 * @returns Object
 */
function animParamParser(attributeContent){
    const params = {};
    if(attributeContent == ""){
        return params;
    }
    attributeContent.split(',').forEach(paramStr=>{
        const keyVal = paramStr.split(':');
        if(keyVal.length > 1){
            params[keyVal[0]] = keyVal[1];
        }
    })
    return params;
}


/**
 * Met en place un observeur pour lancer les
 * animations quand le viewport les rencontre.
 */
function setupAnimations(){
    animationOnScreenDelegate.init();
    animations.forEach( (animation) => {
        document.querySelectorAll(`[x-anim-${animation.name}]`).forEach((el)=>{
            /**
             * Block try catch pour ne pas bloquer le code en cas d'erreur. 
             * Met quand même une erreur dans la console.
             */
            try {
                animation.callback(el, animParamParser(el.getAttribute(`x-anim-${animation.name}`)),animationOnScreenDelegate)
            } catch (err) {
                console.info('Element was not animated,', {
                    element: el,
                    paramsString: el.getAttribute(`x-anim-${animation.name}`),
                    errorMessage: err.message,
                    errorTrace: err.stack
                })
            }
        })
    })
}


export default setupAnimations;